import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { OrderedMap, Map } from 'immutable';
import {
  isCompact,
  isLoose,
  isFeatured,
  isTeleprompter,
  isDisplayView,
} from 'main/components/show/cuesheet/cuesheetViewHelper';
import { populatePrompterSettingsWithDefaults } from 'shared/constants/FeaturedEditorConstants';

import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import UserActions from 'shared/flux/actions/UserActions';
import RouteActions from 'shared/flux/actions/RouteActions';
import { ViewTypes, ViewRelativePaths } from 'shared/constants/CuesheetViews';

import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';

const menuId = 'cs-view-menu';

export default React.createClass({
  displayName: 'ViewMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connectFilter(CuesheetStore, 'show', (st) => st.get('show')),
    PureRenderMixin,
    CuesheetMixin,
  ],

  contextTypes: {
    user: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const showMenu = this.state.popoverVisibility.get(menuId);
    const { displayContent } = this.props;

    return (
      <PopoverMenu
        className="cs-view-menu"
        config={this._getConfigData()}
        show={showMenu}
        displayContent={displayContent}
      />
    );
  },

  _getConfigData() {
    // user, displayThemeSwitch, teamId, eventId, showId, team, event
    const { user, displayThemeSwitch, teamId, eventId, showId } = this.props;

    const isLightTheme = user.get('cuesheetTheme') === 'light';
    const themeTitle = isLightTheme
      ? 'Switch to Dark Theme'
      : 'Switch to Light Theme';

    let items = OrderedMap({});

    if (displayThemeSwitch) {
      items = items.set(
        'lightTheme',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip={TooltipConstants.CSThemeSwitcher}
            >
              <p>{themeTitle}</p>
            </WithTooltip>
          ),
          onClick: () => {
            UserActions.updateField(
              user.get('_id'),
              'cuesheetTheme',
              isLightTheme ? 'dark' : 'light',
            );
          },
        }),
      );
    }

    if (!isCompact()) {
      items = items.set(
        'compact',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip="Switch to compact-view cue sheet"
            >
              <p>Switch to Compact View</p>
            </WithTooltip>
          ),
          onClick: () => {
            this._routeToShow(ViewTypes.Compact);
          },
        }),
      );
    }

    if (!isLoose()) {
      items = items.set(
        'normal',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip="Switch to normal-view cue sheet"
            >
              <p>Switch to Normal View</p>
            </WithTooltip>
          ),
          onClick: () => {
            this._routeToShow(ViewTypes.Loose);
          },
        }),
      );
    }

    if (!isFeatured()) {
      items = items.set(
        'featured',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip="Switch to featured-view cue sheet"
            >
              <p>Switch to Featured View</p>
            </WithTooltip>
          ),
          onClick: () => {
            if (!isTeleprompter()) {
              this._routeToShow(ViewTypes.Featured);
            } else {
              RouteActions.goToFeaturedFromTeleprompter({
                teamId,
                eventId,
                showId,
              });
            }
          },
        }),
      );
    }

    if (!isTeleprompter()) {
      items = items.set(
        'teleprompter',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip="Switch to prompter-view cue sheet"
            >
              <p>Switch to Prompter View</p>
            </WithTooltip>
          ),
          onClick: () => {
            this._routeToTeleprompter();
          },
        }),
      );
    }

    if (!isDisplayView()) {
      items = items.set(
        'display-view',
        Map({
          content: (
            <WithTooltip
              placement="bottom"
              tip="Switch to display-view cue sheet"
            >
              <p>Switch to Display View</p>
            </WithTooltip>
          ),
          onClick: () =>
            RouteActions.goToDisplayView({ teamId, eventId, showId }),
        }),
      );
    }

    return Map({
      id: menuId,
      noCaret: false,
      icon: 'eye',
      iconSize: 2,
      placement: 'bottom',
      onClick: () => PopoverActions.show(menuId),
      onHide: () => PopoverActions.hide(menuId),
      items,
    });
  },

  _routeToShow(type) {
    PopoverActions.hide(menuId, true);

    const { teamId, eventId, showId, user, onRoute } = this.props;

    const params = {
      teamId,
      eventId,
      showId,
      relativePath: ViewRelativePaths[type],
    };

    if (onRoute) onRoute(params);

    UserActions.updatePreference(user.get('_id'), 'cuesheetView', type);
    RouteActions.goToShow(params);
  },

  _routeToTeleprompter() {
    PopoverActions.hide(menuId, true);

    const { onRoute, teamId, eventId, showId } = this.props;
    const { cuesheet } = this.state;
    const userSettings = cuesheet.get('userSettings');
    const featuredColumn = userSettings.get('featuredColumn');

    if (!cuesheet.get('rows') || !cuesheet.get('columns')) {
      return RouteActions.goToTeleprompterInitialization({
        teamId,
        eventId,
        showId,
      });
    }

    const query = populatePrompterSettingsWithDefaults(userSettings);

    if (!featuredColumn) query.displaySplash = true;

    const rowId = cuesheet.getIn(['rows', 0, 'path'])[2];
    const columnId = this._getTeleprompterColumn();

    const params = { teamId, eventId, showId, columnId, rowId };

    if (onRoute) onRoute(params);
    RouteActions.goToTeleprompter(params, query);
  },

  _getTeleprompterColumn() {
    const { cuesheet } = this.state;

    const userSettings = cuesheet.get('userSettings');
    const columns = cuesheet.get('columns');
    const featuredColumn = userSettings.get('featuredColumn');

    if (featuredColumn) return featuredColumn;

    const columnId = cuesheet.getIn(['fullColumnOrder', 0]);

    //In prompter view, we attempt to default to a pa/script column if possible. If we don't
    //find a match for pa or script, we default to the first column in the column order
    const matchedColumn = columns.find((column) => {
      return column.get('title').match(/(pa|script)/gi);
    });

    return matchedColumn ? matchedColumn.get('_id') : columnId;
  },
});
